import { create } from 'zustand';

import type { FilterValues } from "src/types/report";

export type { FilterValues };

// Last-applied dashboard filter values (display values, before any date
// offset). Session-scoped: survives dashboard switches and page navigation,
// resets on full page reload.
interface FilterStore {
  savedFilters: FilterValues;
  updateSavedFilters: (values: FilterValues) => void;
  resetSavedFilters: () => void;
}

const useFilterStore = create<FilterStore>((set) => ({
  savedFilters: {},
  updateSavedFilters: (values) =>
    set((state) => ({ savedFilters: { ...state.savedFilters, ...values } })),
  resetSavedFilters: () => set({ savedFilters: {} }),
}));

export default useFilterStore;
